import { cx } from '@mage-ui/styled-system/css';
import { bubbleSvg } from '@mage-ui/styled-system/recipes';

export const BubbleSvg = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      style={{ display: 'none' }}
      aria-hidden='true'
      tabIndex='-1'
      className={cx(className, bubbleSvg())}
    >
      <symbol viewBox='0 0 99 99' id='bubble-svg'>
        <title>Bubble SVG EOI</title>
        <path
          d='M29.3102 94.7363C29.1024 94.6324 28.9465 94.5804 28.7386 94.4764C28.5307 94.3724 28.2709 94.2684 28.063 94.1644C28.063 94.1644 28.063 94.1644 28.011 94.1644C21.0992 90.8367 15.1748 86.0011 10.6016 80.1775L10.5496 80.1255C10.3937 79.9176 10.2898 79.7616 10.1339 79.5536C3.7937 71.2342 1.78814e-06 60.8351 1.78814e-06 49.552C1.78814e-06 22.1502 22.1906 0 49.526 0C76.8614 0 99 22.1502 99 49.5C99 59.2232 96.1937 68.3225 91.3087 76.0179C90.9969 77.1618 91.0488 78.3057 91.4646 79.5536C93.6472 85.8451 97.9087 98.2201 97.9087 98.2201C97.9087 98.2201 85.5402 93.0725 78.8882 91.0966C77.7969 90.8887 76.4457 91.1486 75.4583 91.6686C69.0661 95.6203 61.7386 98.1161 53.8394 98.844C53.6835 98.844 53.5276 98.896 53.4236 98.896C52.852 98.948 52.2283 99 51.6567 99C51.4488 99 51.2409 99 51.085 99C50.5654 99 50.0976 99 49.578 99C49.422 99 49.2661 99 49.1622 99C49.1102 99 49.0583 99 49.0063 99C42.0425 98.896 35.4425 97.3881 29.4661 94.7363C29.3622 94.7363 29.3102 94.7363 29.3102 94.7363Z'
          fill='currentColor'
        />
      </symbol>
    </svg>
  );
};
